import { render } from "./BalanceDisplay.vue?vue&type=template&id=262837c3"
import script from "./BalanceDisplay.vue?vue&type=script&lang=js"
export * from "./BalanceDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__